var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1281 1.15361L18.2532 0.0286313C17.7236 -0.0932411 17.1798 0.183316 16.9642 0.68018L14.7143 5.93007C14.5174 6.38943 14.6486 6.92849 15.0377 7.24254L17.8782 9.56749C16.1908 13.1627 13.2424 16.1533 9.57217 17.8736L7.24722 15.033C6.92847 14.6439 6.39411 14.5127 5.93474 14.7096L0.684849 16.9595C0.183297 17.1798 -0.0932599 17.7236 0.0286127 18.2532L1.15359 23.1281C1.27077 23.6344 1.72077 24 2.25044 24C14.2549 24 24 14.2736 24 2.25046C24 1.72547 23.6391 1.27079 23.1281 1.15361Z",
    fill: "#57769C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPhone);
export default __webpack_public_path__ + "static/media/logo-phone.bba2892bf9622aecbb8e98c5b4dad165.svg";
export { ForwardRef as ReactComponent };